<script lang="ts">
	import { formatNumberWithSeparators } from "../../../../functions";

    class RisorseGestioneMobilita {
        budgetAnnoEconomicoMobilità: number = 0.0;
        risorseUmaneDedicateMobilità: number = 0;

        constructor(init?: RisorseGestioneMobilita) {
            Object.assign(this, init);
        }
    }

    export let data: RisorseGestioneMobilita = new RisorseGestioneMobilita();

    function isAnyFieldSet(): boolean {
            return (data?.budgetAnnoEconomicoMobilità > 0.0 ||
            data?.risorseUmaneDedicateMobilità > 0) && data !== null;
        }
</script>
<table class="w-full text-xs border border-black table-fixed">
    <thead>
        <tr>
            <th class="border border-black">Voce</th>
            <th class="border border-black">Valore</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td class="text-center border border-black">Budget annuale dedicato alla gestione della mobilità dei dipendenti [€]</td>
            <td class:bg-blue-100={!isAnyFieldSet()} class="text-center border border-black">{formatNumberWithSeparators(data?.budgetAnnoEconomicoMobilità) || '-'}</td>
        </tr>
        <tr>
            <td class="text-center border border-black">Risorse per la gestione della mobilità dei dipendenti</td>
            <td class:bg-blue-100={!isAnyFieldSet()} class="text-center border border-black">{formatNumberWithSeparators(data?.risorseUmaneDedicateMobilità) || '-'}</td>
        </tr>
    </tbody>
</table>